export const Icons = {
  cornerstone: 'cornerstone_logo',
  microsoft: 'microsoft_logo',
  okta: 'okta_logo',
  esqep: 'esqep_logo',
  home: 'home',
  bus: 'bus',
  integrations: 'integrations',
  my_competency: 'my_competency',
  assessment: 'assessment',
  calendar: 'calendar',
  grid: 'grid',
  analytics: 'analytics',
  projects: 'projects',
  admin: 'admin',
  person: 'person',
  email: 'email',
  manage_accounts: 'manage_accounts',
  logout: 'logout',
  info: 'info',
  warning: 'warning',
  error: 'error',
  check_circle: 'check_circle',
  open_in_new: 'open_in_new',
  warning_filled: 'warning_filled',
  schedule_filled: 'schedule_filled',
  cross_circle_filled: 'cross_circle_filled',
  check_circle_filled: 'check_circle_filled',
  question_mark_circle_filled: 'question_mark_circle_filled',
  remove: 'remove',
  ellipsis: 'ellipsis',
  close: 'close',
  school: 'school',
  chalkboard_teacher: 'chalkboard-teacher',
  map_location_dot: 'map-location-dot',
  play: 'play',
  change_circle: 'change_circle',
  autoplay: 'autoplay',
  autopause: 'autopause',
  change_circle_forward: 'change_circle_forward',
  add: 'add',
  edit: 'edit',
  delete: 'delete'
};
